import React from 'react';
import MeetupLocationPicker from './MeetupLocationPicker';
import './MeetupLocationModal.css';

const MeetupLocationModal = ({ isOpen, listing, onSelect, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Choose Meetup Location</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <div className="modal-body">
          <div className="listing-info">
            <h4>Listing: {listing?.title}</h4>
            <p className="listing-location">
              📍 Listed in {listing?.location_city}, {listing?.location_state}
            </p>
          </div>

          <MeetupLocationPicker
            onSelect={onSelect}
            listingLocation={{
              lat: parseFloat(listing?.lat) || 34.0522,
              lng: parseFloat(listing?.lng) || -118.2437
            }}
          />
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeetupLocationModal;
